import AgendaChangeEventMobile from "@/components/agenda/change-event/mobile/Index";
import LinearProgress from "@/components/ui/LinearProgress.tsx";
import ROUTES from "@/config/routes.ts";
import { useModalAction } from "@/contexts/modal/Context.tsx";
import { useMe, useUserChangeEventMutation } from "@/data/user.ts";
import { CHANGE_EVENT_LOCAL_KEY } from "@/utils/agenda.ts";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const AgendaChangeEvent = () => {
  const navigate = useNavigate();
  const breakpoint = useBreakpoint();
  const isSmallSize = ["xs", "sm", "md"].indexOf(breakpoint) !== -1;
  const { openModal } = useModalAction();
  const { me } = useMe();
  const { mutateAsync, isError, isLoading, data } =
    useUserChangeEventMutation();

  const [eventParams, setEventParams] = useState<
    string &
      Record<"user", unknown> &
      Record<"event", unknown> &
      Record<"events", unknown> &
      Record<"expire", unknown>
  >("" as never);
  const [showMobilePage, setShowMobilePage] = useState(false);

   
  const goToDash = () => {
    if (isSmallSize) navigate(ROUTES.agenda, { replace: true });
  };
   

  useEffect(() => {
    let params = localStorage.getItem(CHANGE_EVENT_LOCAL_KEY);
    void (async () => {
      if (!params) {
        goToDash();
        return;
      }

      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        params = JSON.parse(atob(params.slice(2, -2)));
      } catch (e) {
        localStorage.removeItem(CHANGE_EVENT_LOCAL_KEY);
        goToDash();
        return;
      }

      if (!params) {
        localStorage.removeItem(CHANGE_EVENT_LOCAL_KEY);
        goToDash();
        return;
      }

      if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        "user" in params &&
        "event" in params &&
        "events" in params &&
        "expire" in params
      ) {
        setEventParams(params);
        try {
          if (me && me.item.user.token !== params.user) {
            localStorage.removeItem(CHANGE_EVENT_LOCAL_KEY);
            goToDash();
            return;
          }

          const res = await mutateAsync({
            events: params.events as number[],
            event: params.event as number,
            expire: params.expire as number,
            user: params.user as string,
          });

          if (res?.status === false) {
            localStorage.removeItem(CHANGE_EVENT_LOCAL_KEY);
            goToDash();
            return;
          }
          if (isSmallSize) {
            setShowMobilePage(true);
          } else {
            openModal(
              "CHANGE_EVENT_DESKTOP_MODAL",
              {
                response: res,
                eventParams: params,
              },
              {
                heading: "Change class",
                contentClass: "bg-white",
              },
            );
          }
        } catch (e) {
          goToDash();
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSmallSize, me]);

  if (isLoading && !isError) return <LinearProgress />;
  if (isError) return <Navigate to={ROUTES.agenda} replace />;

  return isSmallSize && showMobilePage && data ? (
    <AgendaChangeEventMobile eventParams={eventParams} response={data} />
  ) : null;
};

export default AgendaChangeEvent;
